import { useMemo } from 'react'

import { getModel } from './model-utils'
import BaseTransport from '../transports/common/base-transport'
import { useABConfig } from '../context/ab-config-context'
import { AB_KEY } from '../common/constants'

/**
 * Custom hook that takes in transport data to transform to a model, and its resource type.
 * Returns the model for that transport, if present and mapped to the resource type.
 */
export const useModel = <T extends {}, M extends {}>(
    { data, meta }: Pick<BaseTransport<T>, 'data' | 'meta'>,
    [...deps]: any[] = [],
): M => useMemo(() => getModel(data, meta), [...deps])

export const useABVariant = (experimentName: AB_KEY, variant: number) => {
    const { isVariant, hasABConfigLoaded, isLoading, error } = useABConfig()

    const isProvidedVariantActive = !isLoading && !error && hasABConfigLoaded && isVariant(experimentName, variant)

    return {
        isProvidedVariantActive,
        isLoading,
        error,
    }
}
